import gql from 'graphql-tag';

export const getUser = gql`
query getUser($id: uuid!){
    leads_by_pk(id:$id){
    id
    email
    lead_verified


  }
}
`;

export const forgot = gql`
mutation myMutation($details:ForgotInput!){
  forget_password(details:$details){
    message
    status
  }
}
`;

export const getUserName = gql`

query getUserName($id: uuid!){
  clients_by_pk(id:$id) {
    id
    name
    type
    
  }
}

`;
